import CustomColorPicker from 'designer/component/element/ColorPicker'

const ColorPickerControl = (props) => {
  const { uischema, handleChange, path, config } = props
  const data = config?.jsonData

  const updateColor = (value) => {
    handleChange(path, value)
  }

  return (
    <CustomColorPicker
      {...props}
      uischema={uischema}
      value={data}
      uiKey={uischema.key}
      updateColor={updateColor}
    />
  )
}

export default ColorPickerControl
